class Group {
    public id: string;
    public guidID: string;
    public name: string;
    public description: string;
    public createDate: Date;
    public countCollaborators: number;
    public selecionado: boolean;

}

class GroupRascunho {
    public id: string;
    public name: string;
    public description: string;
    public products: ProdutoRascunho[];
    public guid: string;
    public isEdicao: boolean;

    constructor(name: string, description: string) {
        this.name = name;
        this.description = description;
    }
}

class ProdutoRascunho {
    public produtoId: number;
    public produtoGuid: string;
    public produtoCategoria: number;
    public produtoNome: string;
    public produtoDescImportante: string;
    public standardPeriodCard: number;
    public value: string;
    public maxValue: number;
    public urlIcone: string;
    public color: string;

    constructor(produtoId: number, produtoGuid: string, standardPeriodCard: number, value: string,maxValue: number,color: string, urlIcone: string, produtoNome: string, produtoDescImportante: string, produtoCategoria: number) {
        this.produtoId = produtoId;
        this.produtoGuid = produtoGuid;
        this.standardPeriodCard = standardPeriodCard;
        this.value = value;
        this.maxValue = maxValue;
        this.color = color;
        this.urlIcone = urlIcone;
        this.produtoNome = produtoNome;
        this.produtoCategoria = produtoCategoria;
        this.produtoDescImportante = produtoDescImportante;
    }
}

class GroupIds {
    public id: number;
    public guidID: string;
}

class GroupUpdate {
    public name: string;
    public description: string;
    public assignorGuid: string;
    public managerGuid: string;
    public active: boolean;

    constructor(name: string, description: string, assignorGuid: string, managerGuid: string) {
        this.name = name;
        this.description = description;
        this.assignorGuid = assignorGuid;
        this.managerGuid = managerGuid;
    }
}

class GroupColaborator {
    public collaboratorID: string;
    public collaboratorDocument: string;
    public collaboratorName: string;
}

class GroupColaboratorUpdate {
    public collaboratorIDs: number[];
    public groupGuid: string;
}

class GroupCollaboratorAlter {
    public collaboratorIDs: number[];
    public groupGuid: string;
    public newGroupGuid: string;
}

class GroupCollaboratorDelete {
    public collaboratorIDs: number[];
    public groupGuid: string;
}

class GroupProduct {
    public productID: number;
    public standardPeriodCard: number;
    public value: number;
    public productGuid: string;
    public productCategory: number;
    public assignorContractId: number;
    public productFee: number;
    public isPercent: boolean;
    public expirated: boolean;

    constructor(productID: number, standardPeriodCard: number, value: number) {
        this.productID = productID;
        this.standardPeriodCard = standardPeriodCard;
        this.value = value;
    }
    public productName: string;
    public productColor: string;
    public productIcon: string;
    public productMaxValue: number;
}

class GroupProductUpdate {
    public products: GroupProduct[];
    public groupGuid: string;
    public managerGuid: string;

    constructor(products: GroupProduct[], groupGuid: string, managerGuid: string) {
        this.products = products;
        this.groupGuid = groupGuid;
        this.managerGuid = managerGuid;
    }
}

export class CollaboratorGroup {

    constructor(
        public id: number,
        public name: string,
        public document: string,
        public grupo: string
    ) { }
}

export class CollaboratorGroupPaged {
    constructor(
        public totalResults: number,
        public totalPages: number,
        public collaborators: CollaboratorGroup[]
    ) { }
}

export class CollaboratorsGroupPaged {
    constructor(
        public totalResults: number,
        public totalPages: number,
        public collaborators: GroupColaborator[]
    ) { }
}

export {Group, GroupUpdate, GroupColaborator, GroupColaboratorUpdate, GroupProduct, GroupProductUpdate, GroupCollaboratorAlter, GroupCollaboratorDelete, GroupRascunho, ProdutoRascunho, GroupIds};

